import { React, IconButton, ToggleOn, ToggleOff } from '../../utils/globalImports';

interface ToggleIconButtonProps {
  onClick?: () => void;  // Accept optional onClick prop
  isOn: boolean; // This will control the toggle button state
  disabled?: boolean;
}

const CustomToggleButton: React.FC<ToggleIconButtonProps> = ({ onClick, isOn, disabled }) => {
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        color: isOn ? '#a3c63d' : '#2269ad',  // Green for "On" state, Blue for "Off" state

      }}
    >
      {isOn ? <ToggleOn /> : <ToggleOff />}  {/* Toggle between ToggleOn and ToggleOff icons */}
    </IconButton>
  );
};

export default CustomToggleButton;
